var _rect, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#E11D48"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.75 21.4084L26.8454 22.0978L22.7828 11.9415L24.6895 11.25L28.75 21.4084ZM27.5109 17.8014L26.2903 14.7148L26.9586 14.4734L28.1978 17.5463L27.5109 17.8014ZM14.0973 18.2596C14.0973 17.9443 14.3759 17.6906 14.724 17.6906C15.0578 17.6906 15.3371 17.9443 15.3371 18.2596V26.7739C15.3371 27.094 15.0578 27.3443 14.724 27.3443C14.3759 27.3443 14.0973 27.094 14.0973 26.7739V18.2596ZM16.4352 18.2596C16.4352 17.9443 16.7138 17.6906 17.044 17.6906C17.39 17.6906 17.6672 17.9443 17.6672 18.2596V26.7739C17.6672 27.094 17.39 27.3443 17.044 27.3443C16.7138 27.3443 16.4352 27.094 16.4352 26.7739V18.2596ZM18.6141 18.2596C18.6141 17.9443 18.8898 17.6906 19.2437 17.6906C19.5739 17.6906 19.8496 17.9443 19.8496 18.2596V26.7739C19.8496 27.094 19.5739 27.3443 19.2437 27.3443C18.8898 27.3443 18.6141 27.094 18.6141 26.7739V18.2596ZM20.9548 18.2596C20.9548 17.9443 21.2306 17.6906 21.5651 17.6906C21.9089 17.6906 22.1883 17.9443 22.1883 18.2596V26.7739C22.1883 27.094 21.9089 27.3443 21.5651 27.3443C21.2306 27.3443 20.9548 27.094 20.9548 26.7739V18.2596ZM12.5 30H23.8708V15.292H12.5V30Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.ebba32d1b4622d58be8c0c0e1c4d13d2.svg";
export { ForwardRef as ReactComponent };